import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { getAssetUrl as t } from "../assets.js";
import i from "../core/Error.js";
import { JSONSupportMixin as r } from "../core/JSONSupport.js";
import { clone as o, fixJson as a } from "../core/lang.js";
import s from "../core/Loadable.js";
import { isSome as n } from "../core/maybe.js";
import { isDataProtocol as l, makeAbsolute as p } from "../core/urlUtils.js";
import { property as c } from "../core/accessorSupport/decorators/property.js";
import { ensureClass as d } from "../core/accessorSupport/ensureType.js";
import { reader as u } from "../core/accessorSupport/decorators/reader.js";
import { subclass as m } from "../core/accessorSupport/decorators/subclass.js";
import h from "../geometry/Extent.js";
import y from "./Portal.js";
import g from "./PortalItemResource.js";
import f from "./PortalRating.js";

var _v;

var w = _v = /*#__PURE__*/function (_r) {
  _inherits(v, _r);

  var _super = _createSuper(v);

  function v(e) {
    var _this;

    _classCallCheck(this, v);

    _this = _super.call(this, e), _this.access = null, _this.accessInformation = null, _this.apiKey = null, _this.applicationProxies = null, _this.avgRating = null, _this.categories = null, _this.created = null, _this.culture = null, _this.description = null, _this.extent = null, _this.groupCategories = null, _this.id = null, _this.itemControl = null, _this.licenseInfo = null, _this.modified = null, _this.name = null, _this.numComments = null, _this.numRatings = null, _this.numViews = null, _this.owner = null, _this.ownerFolder = null, _this.portal = null, _this.screenshots = null, _this.size = null, _this.snippet = null, _this.sourceJSON = null, _this.tags = null, _this.title = null, _this.type = null, _this.typeKeywords = null, _this.url = null;
    return _this;
  }

  _createClass(v, [{
    key: "destroy",
    value: function destroy() {
      this.portal = null;
    }
  }, {
    key: "displayName",
    get: function get() {
      var e = this.type,
          t = this.typeKeywords || [];
      var i = e;
      return "Feature Service" === e || "Feature Collection" === e ? i = t.indexOf("Table") > -1 ? "Table" : t.indexOf("Route Layer") > -1 ? "Route Layer" : t.indexOf("Markup") > -1 ? "Markup" : "Feature Layer" : "Image Service" === e ? i = t.indexOf("Elevation 3D Layer") > -1 ? "Elevation Layer" : t.indexOf("Tiled Imagery") > -1 ? "Tiled Imagery Layer" : "Imagery Layer" : "Scene Service" === e ? i = "Scene Layer" : "Scene Package" === e ? i = "Scene Layer Package" : "Stream Service" === e ? i = "Feature Layer" : "Geoprocessing Service" === e && this.portal && this.portal.isPortal ? i = t.indexOf("Web Tool") > -1 ? "Tool" : "Geoprocessing Service" : "Geocoding Service" === e ? i = "Locator" : "Geoenrichment Service" === e ? i = "GeoEnrichment Service" : "Microsoft Powerpoint" === e ? i = "Microsoft PowerPoint" : "GeoJson" === e ? i = "GeoJSON" : "Globe Service" === e ? i = "Globe Layer" : "Vector Tile Service" === e ? i = "Tile Layer" : "netCDF" === e ? i = "NetCDF" : "Map Service" === e ? i = -1 === t.indexOf("Spatiotemporal") && (t.indexOf("Hosted Service") > -1 || t.indexOf("Tiled") > -1) && -1 === t.indexOf("Relational") ? "Tile Layer" : "Map Image Layer" : e && e.toLowerCase().indexOf("add in") > -1 ? i = e.replace(/(add in)/gi, "Add-In") : "datastore catalog service" === e ? i = "Big Data File Share" : "Compact Tile Package" === e ? i = "Tile Package (tpkx)" : "OGCFeatureServer" === e ? i = "OGC Feature Layer" : "web mapping application" === e && t.indexOf("configurableApp") > -1 && (i = "Instant App"), i;
    }
  }, {
    key: "readExtent",
    value: function readExtent(e) {
      return e && e.length ? new h(e[0][0], e[0][1], e[1][0], e[1][1]) : null;
    }
  }, {
    key: "iconUrl",
    get: function get() {
      var e = this.type && this.type.toLowerCase() || "",
          i = this.typeKeywords || [],
          r = "esri/images/portal/",
          o = "16";
      var a,
          s = !1,
          n = !1,
          l = !1,
          p = !1,
          c = !1,
          d = !1;
      return e.indexOf("service") > 0 || "feature collection" === e || "kml" === e || "wms" === e || "wmts" === e || "wfs" === e ? (s = i.indexOf("Hosted Service") > -1, "feature service" === e || "feature collection" === e || "kml" === e || "wfs" === e ? (n = i.indexOf("Table") > -1, l = i.indexOf("Route Layer") > -1, p = i.indexOf("Markup") > -1, c = -1 !== i.indexOf("Spatiotemporal"), d = -1 !== i.indexOf("UtilityNetwork"), a = c && n ? "spatiotemporaltable" : n ? "table" : l ? "routelayer" : p ? "markup" : c ? "spatiotemporal" : s ? "featureshosted" : d ? "utilitynetwork" : "features") : a = "map service" === e || "wms" === e || "wmts" === e ? s || i.indexOf("Tiled") > -1 || "wmts" === e ? "maptiles" : "mapimages" : "scene service" === e ? i.indexOf("Line") > -1 ? "sceneweblayerline" : i.indexOf("3DObject") > -1 ? "sceneweblayermultipatch" : i.indexOf("Point") > -1 ? "sceneweblayerpoint" : i.indexOf("IntegratedMesh") > -1 ? "sceneweblayermesh" : i.indexOf("PointCloud") > -1 ? "sceneweblayerpointcloud" : i.indexOf("Polygon") > -1 ? "sceneweblayerpolygon" : i.indexOf("Building") > -1 ? "sceneweblayerbuilding" : i.indexOf("Voxel") > -1 ? "sceneweblayervoxel" : "sceneweblayer" : "image service" === e ? i.indexOf("Elevation 3D Layer") > -1 ? "elevationlayer" : i.indexOf("Tiled Imagery") > -1 ? "tiledimagerylayer" : "imagery" : "stream service" === e ? "streamlayer" : "vector tile service" === e ? "vectortile" : "datastore catalog service" === e ? "datastorecollection" : "geocoding service" === e ? "geocodeservice" : "geoprocessing service" === e && i.indexOf("Web Tool") > -1 && this.portal && this.portal.isPortal ? "tool" : "layers") : a = "web map" === e || "cityengine web scene" === e ? "maps" : "web scene" === e ? i.indexOf("ViewingMode-Local") > -1 ? "webscenelocal" : "websceneglobal" : "web mapping application" === e && i.indexOf("configurableApp") > -1 ? "instantapps" : "web mapping application" === e || "mobile application" === e || "application" === e || "operation view" === e || "desktop application" === e ? "apps" : "map document" === e || "map package" === e || "published map" === e || "scene document" === e || "globe document" === e || "basemap package" === e || "mobile basemap package" === e || "mobile map package" === e || "project package" === e || "project template" === e || "pro map" === e || "layout" === e || "layer" === e && i.indexOf("ArcGIS Pro") > -1 || "explorer map" === e && i.indexOf("Explorer Document") ? "mapsgray" : "service definition" === e || "csv" === e || "shapefile" === e || "cad drawing" === e || "geojson" === e || "360 vr experience" === e || "netcdf" === e || "administrative report" === e ? "datafiles" : "explorer add in" === e || "desktop add in" === e || "windows viewer add in" === e || "windows viewer configuration" === e ? "appsgray" : "arcgis pro add in" === e || "arcgis pro configuration" === e ? "addindesktop" : "rule package" === e || "file geodatabase" === e || "sqlite geodatabase" === e || "csv collection" === e || "kml collection" === e || "windows mobile package" === e || "map template" === e || "desktop application template" === e || "gml" === e || "arcpad package" === e || "code sample" === e || "form" === e || "document link" === e || "earth configuration" === e || "operations dashboard add in" === e || "rules package" === e || "image" === e || "workflow manager package" === e || "explorer map" === e && i.indexOf("Explorer Mapping Application") > -1 || i.indexOf("Document") > -1 ? "datafilesgray" : "network analysis service" === e || "geoprocessing service" === e || "geodata service" === e || "geometry service" === e || "geoprocessing package" === e || "locator package" === e || "geoprocessing sample" === e || "workflow manager service" === e ? "toolsgray" : "layer" === e || "layer package" === e || "explorer layer" === e ? "layersgray" : "scene package" === e ? "scenepackage" : "mobile scene package" === e ? "mobilescenepackage" : "tile package" === e || "compact tile package" === e ? "tilepackage" : "task file" === e ? "taskfile" : "report template" === e ? "report-template" : "statistical data collection" === e ? "statisticaldatacollection" : "insights workbook" === e ? "workbook" : "insights model" === e ? "insightsmodel" : "insights page" === e ? "insightspage" : "insights theme" === e ? "insightstheme" : "hub initiative" === e ? "hubinitiative" : "hubpage" === e ? "hubpage" : "hub event" === e ? "hubevent" : "hub site application" === e ? "hubsite" : "relational database connection" === e ? "relationaldatabaseconnection" : "big data file share" === e ? "datastorecollection" : "image collection" === e ? "imagecollection" : "style" === e ? "style" : "desktop style" === e ? "desktopstyle" : "dashboard" === e ? "dashboard" : "raster function template" === e ? "rasterprocessingtemplate" : "vector tile package" === e ? "vectortilepackage" : "ortho mapping project" === e ? "orthomappingproject" : "ortho mapping template" === e ? "orthomappingtemplate" : "solution" === e ? "solutions" : "geopackage" === e ? "geopackage" : "deep learning package" === e ? "deeplearningpackage" : "real time analytic" === e ? "realtimeanalytics" : "big data analytic" === e ? "bigdataanalytics" : "feed" === e ? "feed" : "excalibur imagery project" === e ? "excaliburimageryproject" : "notebook" === e ? "notebook" : "storymap" === e ? "storymap" : "survey123 add in" === e ? "survey123addin" : "mission" === e ? "mission" : "mission report" === e ? "missionreport" : "quickcapture project" === e ? "quickcaptureproject" : "pro report" === e ? "proreport" : "urban model" === e ? "urbanmodel" : "web experience" === e ? "experiencebuilder" : "web experience template" === e ? "webexperiencetemplate" : "workflow" === e ? "workflow" : "insights script" === e ? "insightsscript" : "kernel gateway connection" === e ? "kernelgatewayconnection" : "hub initiative template" === e ? "hubinitiativetemplate" : "storymap theme" === e ? "storymaptheme" : "knowledge graph" === e ? "knowledgegraph" : "native application" === e ? "nativeapp" : "native application installer" === e ? "nativeappinstaller" : "link chart" === e ? "linkchart" : "investigation" === e ? "investigation" : "ogcfeatureserver" === e ? "features" : "pro project" === e ? "proproject" : "insights workbook package" === e ? "insightsworkbookpackage" : "apache parquet" === e ? "apacheparquet" : "maps", a ? t(r + a + o + ".png") : null;
    }
  }, {
    key: "isLayer",
    get: function get() {
      return ["Map Service", "Feature Service", "Feature Collection", "Scene Service", "Image Service", "Stream Service", "Vector Tile Service", "WMTS", "WMS"].indexOf(this.type) > -1;
    }
  }, {
    key: "itemUrl",
    get: function get() {
      var e = this.get("portal.restUrl");
      return e ? e + "/content/items/" + this.id : null;
    }
  }, {
    key: "thumbnailUrl",
    get: function get() {
      var e = this.itemUrl,
          t = this.thumbnail;
      return e && t ? this.portal._normalizeUrl("".concat(e, "/info/").concat(t, "?f=json")) : null;
    }
  }, {
    key: "userItemUrl",
    get: function get() {
      var e = this.get("portal.restUrl");
      if (!e) return null;
      var t = this.owner || this.get("portal.user.username");
      if (!t) return null;
      return "".concat(e, "/content/users/").concat(this.ownerFolder ? "".concat(t, "/").concat(this.ownerFolder) : t, "/items/").concat(this.id);
    }
  }, {
    key: "load",
    value: function load(e) {
      var _this2 = this;

      this.portal || (this.portal = y.getDefault());
      var t = this.portal.load(e).then(function () {
        return _this2.sourceJSON ? _this2.sourceJSON : _this2.id && _this2.itemUrl ? _this2.portal._request(_this2.itemUrl, {
          signal: n(e) ? e.signal : null,
          query: {
            token: _this2.apiKey
          }
        }) : {};
      }).then(function (e) {
        _this2.sourceJSON = e, _this2.read(e);
      });
      return this.addResolvingPromise(t), Promise.resolve(this);
    }
  }, {
    key: "addRating",
    value: function addRating(e) {
      var t = {
        method: "post",
        query: {}
      };
      return e instanceof f && (e = e.rating), isNaN(e) || "number" != typeof e || (t.query.rating = e), this.portal._request(this.itemUrl + "/addRating", t).then(function () {
        return new f({
          rating: e,
          created: new Date()
        });
      });
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = {
        access: this.access,
        accessInformation: this.accessInformation,
        applicationProxies: o(this.applicationProxies),
        avgRating: this.avgRating,
        categories: o(this.categories),
        created: o(this.created),
        culture: this.culture,
        description: this.description,
        extent: o(this.extent),
        groupCategories: o(this.groupCategories),
        id: this.id,
        itemControl: this.itemControl,
        licenseInfo: this.licenseInfo,
        modified: o(this.modified),
        name: this.name,
        numComments: this.numComments,
        numRatings: this.numRatings,
        numViews: this.numViews,
        owner: this.owner,
        ownerFolder: this.ownerFolder,
        portal: this.portal,
        screenshots: o(this.screenshots),
        size: this.size,
        snippet: this.snippet,
        tags: o(this.tags),
        thumbnail: this.thumbnail,
        title: this.title,
        type: this.type,
        typeKeywords: o(this.typeKeywords),
        url: this.url
      };
      return this.loaded && (e.loadStatus = "loaded"), new _v({
        sourceJSON: this.sourceJSON
      }).set(e);
    }
  }, {
    key: "createPostQuery",
    value: function createPostQuery() {
      var e = this.toJSON();

      for (var _t in e) {
        "tags" === _t && null !== e[_t] && (e[_t] = e[_t].join(", ")), "typeKeywords" === _t && null !== e[_t] && (e[_t] = e[_t].join(", ")), "extent" === _t && e[_t] && (e[_t] = JSON.stringify(e[_t]));
      }

      return e;
    }
  }, {
    key: "deleteRating",
    value: function deleteRating() {
      return this.portal._request(this.itemUrl + "/deleteRating", {
        method: "post"
      }).then(function () {});
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "json";
      var t = arguments.length > 1 ? arguments[1] : undefined;
      return this.portal._request(this.itemUrl + "/data", _objectSpread(_objectSpread({
        responseType: e
      }, t), {}, {
        query: {
          token: this.apiKey
        }
      }));
    }
  }, {
    key: "fetchRating",
    value: function fetchRating(e) {
      return this.portal._request(this.itemUrl + "/rating", _objectSpread({
        query: {
          token: this.apiKey
        }
      }, e)).then(function (e) {
        return null != e.rating ? (e.created = new Date(e.created), new f(e)) : null;
      });
    }
  }, {
    key: "fetchRelatedItems",
    value: function fetchRelatedItems(e, t) {
      return this.portal._requestToTypedArray(this.itemUrl + "/relatedItems", _objectSpread({
        query: _objectSpread(_objectSpread({}, e), {}, {
          token: this.apiKey
        })
      }, t), _v);
    }
  }, {
    key: "getThumbnailUrl",
    value: function getThumbnailUrl(e) {
      var t = this.thumbnailUrl;
      return t && e && (t += "&w=".concat(e)), t;
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this3 = this;

      return this.portal._request(this.itemUrl, {
        cacheBust: !0,
        query: {
          token: this.apiKey
        }
      }).then(function (e) {
        return _this3.sourceJSON = e, _this3.read(e), _this3;
      });
    }
  }, {
    key: "update",
    value: function update(e) {
      var _this4 = this;

      return this.id ? this.load().then(function () {
        return _this4.portal._signIn();
      }).then(function () {
        var t = e && e.data,
            i = {
          method: "post"
        };
        i.query = _this4.createPostQuery();

        for (var _e in i.query) {
          null === i.query[_e] && (i.query[_e] = "");
        }

        return i.query.clearEmptyFields = !0, null != t && ("string" == typeof t ? i.query.text = t : "object" == typeof t && (i.query.text = JSON.stringify(t))), _this4.portal._request("".concat(_this4.userItemUrl, "/update"), i).then(function () {
          return _this4.reload();
        });
      }) : Promise.reject(new i("portal:item-does-not-exist", "The item does not exist yet and cannot be updated"));
    }
  }, {
    key: "updateThumbnail",
    value: function updateThumbnail(e) {
      var _this5 = this;

      return this.id ? this.load().then(function () {
        return _this5.portal._signIn();
      }).then(function () {
        var t = e.thumbnail,
            i = e.filename,
            r = {
          method: "post"
        };
        if ("string" == typeof t) l(t) ? r.query = {
          data: t
        } : r.query = {
          url: p(t)
        }, n(i) && (r.query.filename = i);else {
          var _e2 = new FormData();

          n(i) ? _e2.append("file", t, i) : _e2.append("file", t), r.body = _e2;
        }
        return _this5.portal._request("".concat(_this5.userItemUrl, "/updateThumbnail"), r).then(function () {
          return _this5.reload();
        });
      }) : Promise.reject(new i("portal:item-does-not-exist", "The item does not exist yet and cannot be updated"));
    }
  }, {
    key: "fetchResources",
    value: function () {
      var _fetchResources = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var e,
            t,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                t = _args.length > 1 ? _args[1] : undefined;
                _context.next = 4;
                return import("./support/resourceUtils.js");

              case 4:
                return _context.abrupt("return", _context.sent.fetchResources(this, e, t));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchResources() {
        return _fetchResources.apply(this, arguments);
      }

      return fetchResources;
    }()
  }, {
    key: "addResource",
    value: function () {
      var _addResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t, i) {
        var r;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return import("./support/resourceUtils.js");

              case 2:
                r = _context2.sent;
                return _context2.abrupt("return", (e.portalItem = this, r.addOrUpdateResource(e, "add", t, i)));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addResource(_x, _x2, _x3) {
        return _addResource.apply(this, arguments);
      }

      return addResource;
    }()
  }, {
    key: "removeResource",
    value: function () {
      var _removeResource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, t) {
        var r;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return import("./support/resourceUtils.js");

              case 2:
                r = _context3.sent;

                if (!(e.portalItem && e.portalItem.itemUrl !== this.itemUrl)) {
                  _context3.next = 5;
                  break;
                }

                throw new i("removeresource:portal-item-mismatch", "The portal item associated with the provided resource does not match the item");

              case 5:
                return _context3.abrupt("return", r.removeResource(this, e, t));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function removeResource(_x4, _x5) {
        return _removeResource.apply(this, arguments);
      }

      return removeResource;
    }()
  }, {
    key: "removeAllResources",
    value: function () {
      var _removeAllResources = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return import("./support/resourceUtils.js");

              case 2:
                return _context4.abrupt("return", _context4.sent.removeAllResources(this, e));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function removeAllResources(_x6) {
        return _removeAllResources.apply(this, arguments);
      }

      return removeAllResources;
    }()
  }, {
    key: "resourceFromPath",
    value: function resourceFromPath(e) {
      return new g({
        portalItem: this,
        path: e
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = this.extent,
          t = {
        created: this.created && this.created.getTime(),
        description: this.description,
        extent: e && [[e.xmin, e.ymin], [e.xmax, e.ymax]],
        id: this.id,
        modified: this.modified && this.modified.getTime(),
        name: this.name,
        owner: this.owner,
        ownerFolder: this.ownerFolder,
        snippet: this.snippet,
        tags: this.tags,
        thumbnail: this.thumbnail,
        title: this.title,
        type: this.type,
        typeKeywords: this.typeKeywords,
        url: this.url
      };
      return a(t);
    }
  }, {
    key: "_getPostQuery",
    value: function _getPostQuery() {
      var e = this.toJSON();

      for (var _t2 in e) {
        "tags" === _t2 && null !== e[_t2] && (e[_t2] = e[_t2].join(", ")), "typeKeywords" === _t2 && null !== e[_t2] && (e[_t2] = e[_t2].join(", ")), "extent" === _t2 && e[_t2] && (e[_t2] = JSON.stringify(e[_t2]));
      }

      return e;
    }
  }], [{
    key: "from",
    value: function from(e) {
      return d(_v, e);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e) {
      if (!e) return null;
      if (e.declaredClass) throw new Error("JSON object is already hydrated");
      return new _v({
        sourceJSON: e
      });
    }
  }]);

  return v;
}(r(s));

e([c({
  type: ["private", "shared", "org", "public"]
})], w.prototype, "access", void 0), e([c()], w.prototype, "accessInformation", void 0), e([c({
  type: String
})], w.prototype, "apiKey", void 0), e([c({
  json: {
    read: {
      source: "appProxies"
    }
  }
})], w.prototype, "applicationProxies", void 0), e([c()], w.prototype, "avgRating", void 0), e([c()], w.prototype, "categories", void 0), e([c({
  type: Date
})], w.prototype, "created", void 0), e([c()], w.prototype, "culture", void 0), e([c()], w.prototype, "description", void 0), e([c({
  readOnly: !0
})], w.prototype, "displayName", null), e([c({
  type: h
})], w.prototype, "extent", void 0), e([u("extent")], w.prototype, "readExtent", null), e([c()], w.prototype, "groupCategories", void 0), e([c({
  readOnly: !0
})], w.prototype, "iconUrl", null), e([c()], w.prototype, "id", void 0), e([c({
  readOnly: !0
})], w.prototype, "isLayer", null), e([c()], w.prototype, "itemControl", void 0), e([c({
  readOnly: !0
})], w.prototype, "itemUrl", null), e([c()], w.prototype, "licenseInfo", void 0), e([c({
  type: Date
})], w.prototype, "modified", void 0), e([c()], w.prototype, "name", void 0), e([c()], w.prototype, "numComments", void 0), e([c()], w.prototype, "numRatings", void 0), e([c()], w.prototype, "numViews", void 0), e([c()], w.prototype, "owner", void 0), e([c()], w.prototype, "ownerFolder", void 0), e([c({
  type: y
})], w.prototype, "portal", void 0), e([c()], w.prototype, "screenshots", void 0), e([c()], w.prototype, "size", void 0), e([c()], w.prototype, "snippet", void 0), e([c()], w.prototype, "sourceJSON", void 0), e([c()], w.prototype, "tags", void 0), e([c()], w.prototype, "thumbnail", void 0), e([c({
  readOnly: !0
})], w.prototype, "thumbnailUrl", null), e([c()], w.prototype, "title", void 0), e([c()], w.prototype, "type", void 0), e([c()], w.prototype, "typeKeywords", void 0), e([c()], w.prototype, "url", void 0), e([c({
  readOnly: !0
})], w.prototype, "userItemUrl", null), w = _v = e([m("esri.portal.PortalItem")], w);
var b = w;
export { b as default };